import type { SymbolDefinition } from "../types.ts";

export const contactor1p: SymbolDefinition = {
  id: "ep-contactor-1p",
  familyKey: "contactor",
  deviceKind: "contactor",
  version: "0.1.0",
  label: { sv: "Kontaktor 1-polig", en: "Contactor 1-pole" },
  description: { sv: "Enpolig kontaktor.", en: "Single-pole contactor." },
  viewBox: "0 0 24 24",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square">
      <line x1="12" y1="2" x2="12" y2="8"/>
      <line x1="10" y1="8" x2="16" y2="15"/>
      <line x1="12" y1="16" x2="12" y2="22"/>
    </g>
  `,
  terminals: [
    { id: "in", kind: "phase", label: "L1", position: "top", offset: 0.5 },
    { id: "out", kind: "phase", label: "T1", position: "bottom", offset: 0.5 },
  ],
  designationPrefix: "K",
  searchKeywords: ["kontaktor", "contactor"],
};
